import Comment from 'models/Comment';
import React, { useMemo, useState } from 'react';
import dayjs from 'dayjs';

function SingleComment({ comment }: { comment: Comment }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const shortenedComment = useMemo(() => comment.comment.slice(0, 200), [comment.comment]);

    return (
        <div className="flex gap-3">
            <div className="image flex-shrink-0">
                <img src={comment.user_picture} width={40} height={40} className="rounded-full rounded-bl-none" />
            </div>
            <div className="comment">
                <div className="flex items-center gap-2">
                    <strong>
                        {comment.user_first_name} {comment.user_last_name}
                    </strong>{' '}
                    • <span className="text-gray-400 text-sm">{dayjs(comment.created_at).format('DD. MM. YYYY')}</span>
                </div>
                <p className="mt-2 whitespace-pre-wrap">
                    {!isExpanded && shortenedComment.length < comment.comment.length
                        ? shortenedComment + '...'
                        : comment.comment}
                    {shortenedComment.length < comment.comment.length && (
                        <a
                            className="text-brand whitespace-nowrap"
                            href={`#read-more-${comment.id}`}
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            Preberi {isExpanded ? 'manj' : 'več'}
                        </a>
                    )}
                </p>
            </div>
        </div>
    );
}

export default SingleComment;
